import { AnimalRepository } from '../modules/animals/repositories/AnimalRepository';
import { ToPerformRepository } from '../modules/toPerform/repositories/ToPerformRepository';
import { IAnimal } from '../modules/animals/entities/IAnimal';
import { IToPerform } from '../modules/toPerform/entities/IToPerform';

type Arguments = {
  animalTable: Dexie.Table<IAnimal, number>;
  toPerformTable: Dexie.Table<IToPerform, number>;
  propriedade_id: string;
};

export async function AnimalsInToPerform({
  animalTable,
  toPerformTable,
  propriedade_id,
}: Arguments) {
  const animalsRepository = new AnimalRepository(animalTable);
  const toPerformRepository = new ToPerformRepository(toPerformTable);

  const animals = await animalsRepository.findByPropriedadeId(propriedade_id);

  const toPerformData = await toPerformRepository.findAllAnimals();

  const animaisToPerform: IAnimal[] = toPerformData.map(item => {
    return { id: item.id, ...item.data, estado: 'ativo', imagens: [] };
  });

  const verification = animals
    .filter(item => animaisToPerform.some(animal => item.id !== animal.id))
    .filter((item, _, array) => array.includes(item) === false);

  animals.push(...verification);

  return animals;
}
